export default __webpack_public_path__ + "static/media/LogoVivezClichy.d9f3bec1.png";